<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm y menores: -->
        <v-navigation-drawer
            v-if="isAuthenticated"
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
        >
            <v-list dense class="pt-0">

                <v-list-item class="centenario-brown" @click="onEvents">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-silverware-fork-knife</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                         <v-list-item-title>Eventos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item class="centenario-brown" @click="onUsers">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-account-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Usuarios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="centenario-brown" @click="onEventPackages">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-package-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Paquetes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="centenario-brown" @click="onServices">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-flag</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Servicios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="centenario-brown" @click="onPayments">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-receipt</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Relación de pagos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item class="centenario-brown" @click="onLogout" color="teal darken-1">
                    <v-list-item-action>
                        <v-icon color="brown darken-2">mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="brown darken-2">Salir</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm y menores-->

        <v-app-bar v-if="isAuthenticated" flat fixed app color="grey lighten-5" clipped-left>
            <v-app-bar-nav-icon
                v-if="isAuthenticated"
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-app-bar-nav-icon>

            <router-link to="/">
                <img height="55" :src="mainLogo" @click="onHome" class="logo-hover"/>
            </router-link>

            <v-toolbar-title class="hidden-sm-and-down">
                <div class="centenario-green title">&nbsp; &nbsp;{{ userName }}</div>
            </v-toolbar-title>
            
            <v-toolbar-title class="hidden-md-and-up">
                <div class="centenario-green subtitle-1">&nbsp; &nbsp;{{ userName }}</div>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn
                    text
                    class="text-none"
                    @click="onEvents">
                    <v-icon color="brown darken-2">mdi-silverware-fork-knife</v-icon>&nbsp;Eventos
                </v-btn>
                <v-menu offset-y>
                     <template v-slot:activator="{ on }">
                        <v-btn
                            text
                            class="text-none"
                            color="brown darken-2" v-on="on">
                            <v-icon color="brown darken-2">mdi-cog</v-icon>&nbsp;Herramientas
                        </v-btn>
                    </template>
                    <v-list color="grey lighten-5">
                        <v-list-item @click="onUsers">
                            <v-list-item-title>
                                <v-icon color="brown darken-2">mdi-account-multiple</v-icon>&nbsp; Usuarios
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list color="grey lighten-5">
                        <v-list-item @click="onEventPackages">
                            <v-list-item-title>
                                <v-icon color="brown darken-2">mdi-package-variant</v-icon>&nbsp; Paquetes
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list color="grey lighten-5">
                        <v-list-item @click="onServices">
                            <v-list-item-title>
                                <v-icon color="brown darken-2">mdi-flag</v-icon>&nbsp; Servicios
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-list color="grey lighten-5">
                        <v-list-item @click="onPayments">
                            <v-list-item-title>
                                <v-icon color="brown darken-2">mdi-receipt</v-icon>&nbsp; Relación de pagos
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-btn
                    text
                    class="text-none"
                    @click="onLogout">
                    <v-icon color="brown darken-2">mdi-exit-to-app</v-icon>&nbsp;Salir</v-btn
                >
            </v-toolbar-items>
            <!-- Fin del menú visible si se inició sesión -->
        </v-app-bar>

        <!-- <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay> -->
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            //valid: false
            //     e1: true,
            //     password: '',
            //     passwordRules: [v => !!v || 'Introduzca la contraseña'],
            //     email: '',
            //     emailRules: [
            //         v => !!v || 'Introduzca su correo electrónico',
            //         v =>
            //             /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            //             'Introduzca un correo válido'
            //     ],
        };
    },
    components: {
        LocaleChanger,
    },
    methods: {
        onHome() {
            if (!this.isAuthenticated) {
                this.drawer = false;
            }
        },
        onEvents() {
            this.$router.push('/events').catch(err => {});
            this.drawer = false;
        },
        onUsers() {
            this.$router.push('/users');
            this.drawer = false;
        },
        onEventPackages() {
            this.$router.push('/packages');
            this.drawer = false;
        },
        onServices() {
            this.$router.push('/services');
            this.drawer = false;
        },
        onPayments() {
            this.$router.push('/payments');
            this.drawer = false;
        },
        onLogout() {
            //console.log('logout');
            //this.overlay = true;
            this.$store.dispatch('logout');
            this.drawer = false;
        },
        
    },
    computed: {
        ...mapGetters([
            'appTitle',
            'mainLogo',
            'mainLogoAppBar',
            'isAuthenticated',
            'userName',
        ]),
    },
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}

.logo-hover:hover {
    cursor: pointer;
}

.usr-name {
    font-size: 14px;
    color: #00897b;
}

.centenario-brown {
    color: #6c3200;
}

.centenario-green {
    color: #008F03;
}

.tw-gray {
    /* color: #757575; */
    /* grey darken-1 */
    color: red;
}
</style>
